import { useEffect, useState } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { useAuth } from '../contexts/auth';
import { useModals } from '../contexts/modals';
import Cadastro from '../pages/Cadastro';
import Feed from '../pages/Feed';
import Inicio from '../pages/Inicio';
import Login from '../pages/Login';
import Profile from '../pages/Profile';

export default function Navigation() {
  const { user } = useAuth();
  const { currentModal } = useModals();
  const [hasUser, setHasUser] = useState<boolean>(false);

  useEffect(() => {
    if (user) {
      setHasUser(true)
    } else {
      setHasUser(false)
    }
  }, [user])

  return (
    <BrowserRouter>
      {currentModal}
      <Routes>
        {hasUser ? (
          <>
            <Route path="/*" element={<Feed />} />
            <Route path="/Cadastro" element={<Cadastro />} />
            <Route path="/Inicio" element={<Inicio />} />
            <Route path="/Login" element={<Login />} />
            <Route path="/Profile/*" element={<Profile />} />
          </>
        ) : (
          <>
            <Route path="/" element={<Inicio />} />
            <Route path="/Cadastro" element={<Cadastro />} />
            <Route path="/Inicio" element={<Inicio />} />
            <Route path="/Login" element={<Login />} />
          </>
        )}
      </Routes>
    </BrowserRouter>
  );
}